module.exports = __webpack_public_path__ + "static/img/voorhis.3bd2256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/voorhis.png
// module id = YNow
// module chunks = 0